import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import AIAssistant from "@app/pippa/assets/ai-assistant.png";
import { QuickReplyType } from "@app/pippa/models";
import QuickReply from "../quickReply/quickReply";
import "./welcomeMessage.scss";

const messages = defineMessages({
  avatarAtlText: {
    id: "avatarAtlText",
    defaultMessage: "GenAI avatar",
  },
  welcomeMessageTitle: {
    id: "welcomeMessageTitle",
    defaultMessage: "Hi, I’m Natera Results Assistant",
  },
  welcomeMessageSubtitle: {
    id: "welcomeMessageSubtitle",
    defaultMessage:
      "I’m here to help you understand your Signatera test results. Tap an option below or type your question in the chat box.",
  },
});

interface Props {
  quickReplies?: QuickReplyType[];
}

const WelcomeMessage: FC<Props> = ({ quickReplies }) => {
  const intl = useIntl();

  return (
    <div className="welcome-message__container">
      <img
        className="welcome-message__avatar"
        src={AIAssistant}
        alt={intl.formatMessage(messages.avatarAtlText)}
      />
      <h2 className="welcome-message__title">
        {intl.formatMessage(messages.welcomeMessageTitle)}
      </h2>
      <p className="welcome-message__subtitle">
        {intl.formatMessage(messages.welcomeMessageSubtitle)}
      </p>
      {!!quickReplies?.length && (
        <div className="welcome-message__quick-replies">
          <QuickReply replies={quickReplies} />
        </div>
      )}
    </div>
  );
};

export default WelcomeMessage;
